import { SystemIcon, Typography } from '@wishket/design-system';

interface PersonalizedAreaSelectProps {
  text: string;
  onClick: () => void;
}

const PersonalizedAreaSelectButton = ({
  text,
  onClick,
}: PersonalizedAreaSelectProps) => {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-1.5 rounded-2xl border border-primary-50 bg-primary-10 py-1 pl-3 pr-2"
    >
      <Typography
        variant="subTitle1"
        className="font-bold text-primary-500 desktop:typo-title3"
      >
        {text}
      </Typography>
      <SystemIcon name="medium_menu_down" className="text-primary-500" />
    </button>
  );
};

export default PersonalizedAreaSelectButton;
